import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { EventEmitter, OnDestroy, Output } from '@angular/core';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

const enum Status {
  OFF = 0,
  RESIZE = 1,
  MOVE = 2
}

@Component({
  selector: 'app-transaction-lite',
  templateUrl: './transaction-lite.component.html',
  styleUrls: ['./transaction-lite.component.css']
})
export class TransactionLiteComponent implements OnInit, OnDestroy {

  invoicePrimaryDetails: any = { urn: '', docType: '', currentStatus: '', country: '', urnCreatedDate: '', source: '', aging: '', assigned_to_user: '' };
  documentDetailId: number = 0;
  isReadonlyMode: boolean = false;

  showHistory: boolean = false;
  isLoadedTranHistory: boolean = false;
  isLoadedProgressHistory: boolean = false;

  isShowHistoryButton: boolean = true;
  isShowProgressButton: boolean = true;
  isShowPriorityButton: boolean = true;
  isDisplayPDFViewer = true;
  hasChecklistInHistory: boolean = false;
  hasRejectReasonInHistory: boolean = false;

  transactionComment: string = "";
  fileBase64FileString: string = "";
  fileControlType = 'file'; //for SSA fixing (we have checked upload file type)
  fileName = "No File Chosen";
  attachmentMailContent: string = '';
  attachmentList = [];

  transactionDetail: any;
  transactionHistoryList = [];
  fileAttachmentHistoryList = [];
  activeHistoryId: number = 0;

  doaHistory: any = [];

  lineItemTabName: string = "";
  lineLevelItemList = [];
  lineLevelItem: any;
  isPOLineItem: boolean = false;

  isDOAExists: boolean = false;
  isDOAParallel: boolean = false;
  doaApproverList: any = [];
  forwardApproverList: any = [];
  doaFields: any = [];
  doaMatrix: any = {};
  selectedDOAApprover: number = 0;
  selectedForwardApprover: number = 0;

  dynamicTabs: any[];
  activeTab: any;
  transactionFieldList = [];
  processQueue: any[] = []
  dateFormat = new DatePipe('en-US');
  restrictedKeywords: any = [];
  modalRef: NgbModalRef = null;
  mainModalRef: NgbModalRef = null;
  isCommentExpand: boolean = false;
  isBright: boolean = true;
  isShowUploadedDocs: boolean = false;
  searchDoaApprover: string = '';
  searchForwardApprover: string = '';
  isPageFullyLoaded: boolean = false;
  supportDocValidFileExtensions = [];
  supportDocFileSize = {};
  fetchSesLineitemAPI: string = '';
  sesLineitemList: any = [];

  @ViewChild('transactionModal') public transactionModelTemplate: TemplateRef<any>;
  @ViewChild('forwardApproverModal') public forwardApproverModal: TemplateRef<any>;
  @ViewChild('fileUpload') fileInput: ElementRef;
  @ViewChild('rbgDOA') public rbgDOA: TemplateRef<any>;
  @ViewChild('sesLineitemModal') sesLineitemModal: ElementRef;

  @ViewChild('widgetsContent', { read: ElementRef })
  public widgetsContent!: ElementRef<any>;

  @Output() reloadPage = new EventEmitter<any>();

  subscription: any;
  step = 0;
  modalReference: any;
  // add word count var
  wordsTotal: any = 1000;

  constructor(private modalService: NgbModal, private dataService: DataService, public commonService: CommonService, private dialog: MatDialog, private router: Router,private encryptDecryptservice:EncryptDecryptService,private memorystore: MemoryStorageService) {

    this.subscription = EmmiterService.get("transactionLiteModal").subscribe(async data => {
      if (data) {
        this.documentDetailId = data.documentDetailId;
        this.isReadonlyMode = data.isReadonlyMode;
        await this.getTransactionDetail();
        this.openModal();
      }
    });

    this.restrictedKeywords = this.commonService.getRestrictedKeywords()

    EmmiterService.get('DayNightClick').subscribe((res) => {
      this.isBright = res;
    });
  }

  ngOnInit(): void {
  }
  // add word count function start
  function(data) {
    this.wordsTotal = this.wordsTotal - data.length
  }
  // add word count function end
  ngOnDestroy() {
    this.clearAll()
    this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  openModal() {

    this.mainModalRef = this.modalService.open(this.transactionModelTemplate,
      { windowClass: 'transaction-lite', ariaLabelledBy: 'modal-basic-title', size: 'lg', centered: true, keyboard: false });

    this.mainModalRef.result.then((result) => {
      this.clearAll();
    }, (reson) => {
      this.clearAll();
    });

  }

  clearAll() {
    this.documentDetailId = 0;

    this.transactionDetail = {};
    this.transactionHistoryList = [];
    this.fileAttachmentHistoryList = [];

    this.fileName = "No File Chosen";
    this.transactionComment = "";
    this.fileBase64FileString = "";

    this.lineItemTabName = "";
    this.lineLevelItemList = [];
    this.lineLevelItem = {};

    this.dynamicTabs = [];
    this.transactionFieldList = [];

    this.showHistory = false;

    this.isLoadedTranHistory = false;
    this.isLoadedProgressHistory = false;

    this.isShowHistoryButton = true;
    this.isShowProgressButton = true;
    this.isShowPriorityButton = true;
    this.isDisplayPDFViewer = true;

    this.isDOAExists = false;
    this.isDOAParallel = false;
    this.doaApproverList = [];
    this.forwardApproverList = [];
    this.doaFields = [];
    this.doaMatrix = {};
    this.selectedDOAApprover = 0;
    this.selectedForwardApprover = 0;
    this.searchForwardApprover = '';
    this.searchDoaApprover = '';
    this.isPageFullyLoaded = false;
  }

  async getTransactionDetail() {

    if (this.documentDetailId == 0 || this.documentDetailId == null)
      return;

    let params = new HttpParams;
    params = params.append("document_detail_id", this.documentDetailId.toString());//Uncommented by imran 9-1-2026
    params = params.append("role_id", this.commonService.selectedRole)
    params = params.append("subgroup_id", this.commonService.selectedSubgroup)
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));//Added by imran on 01-04-26
    // params = params.append("document_detail_id", this.encryptDecryptservice.encryptUsingAES256(this.documentDetailId.toString()));
    // params = params.append("role_id", this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole))
    // params = params.append("subgroup_id", this.encryptDecryptservice.encryptUsingAES256( this.commonService.selectedSubgroup))
    await this.dataService.getDataPromise('transaction', params).then(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res != null && res.success == true) {
          this.transactionDetail = res.data;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error IM1 IM1")
        }
      }


      if (this.transactionDetail != null) {

        this.dynamicTabs = this.transactionDetail.tabs;//.filter(tab => tab.tab_field_type != "LINEITEM" && tab.tab_field_type != "POLINEITEM")
        this.activeTab = this.dynamicTabs[0];
        this.processQueue = this.transactionDetail.next_processes;

        this.invoicePrimaryDetails = {
          urn: this.transactionDetail.urn,
          docType: this.transactionDetail.document_type_name,
          currentStatus: this.transactionDetail.process_name,
          country: this.transactionDetail.hasOwnProperty('subgroup_name') ? this.transactionDetail.subgroup_name : '',
          urnCreatedDate: this.dateFormat.transform(new Date(this.transactionDetail.created_date), 'dd-MMM-yyyy'),
          source: this.transactionDetail.source,
          aging: "",
          priority: this.transactionDetail.priority,
          assigned_to_user: this.transactionDetail.assigned_to_user_display_name
        };

        this.isShowHistoryButton = (this.transactionDetail.options[0].history == "1") ? true : false;
        this.getTransactionFields();
        this.isDOAExists = res.data.has_doa == 1;
        if (this.isDOAExists) {
          if (res.data.doa_fields != null) {
            res.data.doa_fields.forEach(element => {
              element.doa_rule = JSON.parse(element.doa_rule);
            });
            this.doaFields = res.data.doa_fields;
          }
          else {
            this.doaFields = [];
          }

        }

        this.fetchSesLineitemAPI = '';
        if (this.transactionDetail.realtime_apis != null) {
          this.transactionDetail.realtime_apis.forEach(api => {
            if (api.API_NAME == 'SES_LINEITEM_FETCH') {
              this.fetchSesLineitemAPI = api;
            }
          });
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    }).catch(err => {
    });
  }

  getTransactionFields() {
    this.getSupportingDocuments();
    this.transactionFieldList = [];
    let count = 0;
    this.transactionDetail.tabs.forEach(async tab => {

      let params = new HttpParams;
      //Uncommented and commented by imran 09-01-2026
       params = params.append("document_detail_id", this.documentDetailId.toString());
       params = params.append("document_type_id", this.transactionDetail.document_type_id.toString());
       params = params.append("role_id", this.commonService.selectedRole);
       params = params.append("project_id", this.commonService.selectedProject);
       params = params.append("tab_id", tab.tab_id.toString());
       params = params.append("process_id", this.transactionDetail.process_id.toString());
       params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));//Added by imran on 01-04-26
       // params = params.append("document_detail_id",this.encryptDecryptservice.encryptUsingAES256(this.documentDetailId.toString()));
      // params = params.append("document_type_id",this.encryptDecryptservice.encryptUsingAES256( this.transactionDetail.document_type_id.toString()));
      // params = params.append("role_id", this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole));
      // params = params.append("project_id", this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
      // params = params.append("tab_id", this.encryptDecryptservice.encryptUsingAES256(tab.tab_id.toString()));
      // params = params.append("process_id", this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.process_id.toString()));
      params = params.append("isReadonlyMode", true);
     
      await this.dataService.getDataPromise('transaction-tabs', params).then(res => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          count++;
          if (res == null || res == undefined) {
            return;
          }
          if (tab.tab_field_type == 'LINEITEM' || tab.tab_field_type == "POLINEITEM") {
            this.lineLevelItem = res.data[0];
            this.lineItemTabName = tab.tab_name;

            if (tab.tab_field_type == "POLINEITEM") {
              this.isPOLineItem = true;
            }
            else {
              this.isPOLineItem = false;
            }

            res.data.forEach(row => {
              let lst = row.field_value_details;
              if (lst != null && lst != undefined) {
                lst.forEach(line => {
                  this.lineLevelItemList.push(line);
                })
              }
            });
          }
          else {
            this.transactionFieldList[tab.tab_id] = res.data;

            this.transactionFieldList[tab.tab_id].forEach(item => {
              item.field_details.forEach(async field => {
                if (field.control_type == 'DROPDOWN' && !field.hasOwnProperty('options') && field.field_value != null && field.field_value != '') {
                  if (field.is_dependant == 1) {
                    this.getDependantFields(field.field_mapping_detail_id, field.field_value);
                  }
                  field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id, field.field_value);
                  let option = field.options.find(p => p['id'] == field.field_value);
                  if (option != undefined || option != null)
                    field.dropdown_field_text = option['name'];
                }
              });
            });
          }
          if (this.transactionDetail.tabs.length == count) {
            if (this.isDOAExists) {
              setTimeout(() => {
                this.getDOAMatrix();
              }, 2000);
            }
            else {
              this.isPageFullyLoaded = true;
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error IM1 IM2")
          }
        }


      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      }).catch(err => {
      });

      // if (this.transactionDetail.tabs[0].tab_id == tab.tab_id) {
      //   if (this.isDOAExists) {
      //     setTimeout(() => {
      //       this.getDOAMatrix();
      //     }, 3000);
      //   }
      //   else {
      //     this.isPageFullyLoaded = true;
      //   }
      // }
    });
  }

  getDependantFields(fieldMappingDetailId: number, selectedValue: any) {
    let params = new HttpParams();
    params = params.append('field_mapping_detail_id', fieldMappingDetailId);
    params = params.append('selected_value', selectedValue);
params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('dependant', params).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != undefined && res.data != null) {
          if (res.data.length > 0) {
            res.data.forEach((ele) => {
              ele.values = JSON.parse(ele.values);
              if (ele.control_type == 'DROPDOWN') {
                this.transactionFieldList[this.transactionDetail.tabs.filter(x => x.tab_field_type == 'NORMAL')[0].tab_id].forEach(section => {
                  section.field_details.forEach(field => {
                    if (field.db_column_name == ele.db_column_name) {
                      const uniqueData = [...new Map(ele.values.map(item => [item['name'], item])).values()];
                      field.options = uniqueData;
                      let option = field.options.find(p => p['id'] == field.field_value);
                      if (option != undefined || option != null)
                        field.dropdown_field_text = option['name'];
                    }
                  });
                });
              }
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error IM1")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  getDOAMatrix() {

    this.doaFields.forEach((x) => {
      x.doa_rule.forEach(r => {

        this.transactionFieldList[this.transactionDetail.tabs.filter(x => x.tab_field_type == 'NORMAL')[0].tab_id].forEach(section => {
          section.field_details.forEach(field => {
            if (field.db_column_name == r.DB_COLUMN_NAME) {
              if (field.control_type == 'DROPDOWN') {
                r.VALUE = field.dropdown_field_text;
              } else {
                r.VALUE = field.field_value;
              }
            }
          });
        });
      });
    });

    let params = new HttpParams();
    params = params.append('document_detail_id', this.documentDetailId);
    params = params.append('document_type_id', this.transactionDetail.document_type_id);
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('process_id', this.transactionDetail.process_id);
    params = params.append('next_process_id', 0);
    params = params.append('field_vals', this.doaFields.length > 0 ? JSON.stringify(this.doaFields) : null);

    this.dataService.getData('doa-matrix', params).subscribe((res) => {
      this.isPageFullyLoaded = true;
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          if (res.data == null) {
            this.doaApproverList = [];
            this.commonService.showMessageBox(res.errorMessage, 'Alert');
            return;
          }
          else {
            this.doaMatrix = res.data.doa_matrix;
            this.isDOAParallel = this.doaMatrix.doa_matrix_name.toLowerCase().includes('parallel');
            this.doaApproverList = res.data.doa_approvers;
            if (this.doaApproverList.length == 1) {
              this.selectedDOAApprover = Number(this.doaApproverList[0].USER_ID);
            }
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error IM1")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  submitDOA(documentHistoryId: number, nextProcessId: number) {

    let doaAssignedTo = [];
    let doaLevel = 0;

    if (this.doaMatrix.forward_process_id == nextProcessId) {
      doaAssignedTo = [this.selectedForwardApprover];
    } else {
      let selectedApprover = this.doaApproverList.find(x => x.USER_ID == this.selectedDOAApprover);
      doaLevel = selectedApprover != undefined ? selectedApprover['DOA Level'] : 0;
      if (this.isDOAParallel) {
        this.doaApproverList.forEach(user => {
          if (user['DOA Level'] == doaLevel) {
            doaAssignedTo.push(user.USER_ID);
          }
        });
      } else if (this.selectedDOAApprover > 0) {
        doaAssignedTo = [this.selectedDOAApprover];
      }

      this.doaFields.forEach((x) => {
        x.doa_rule.forEach(r => {
          this.transactionFieldList[this.transactionDetail.tabs.filter(x => x.tab_field_type == 'NORMAL')[0].tab_id].forEach(section => {
            section.field_details.forEach(field => {
              if (field.db_column_name == r.DB_COLUMN_NAME) {
                if (field.control_type == 'DROPDOWN') {
                  r.VALUE = field.dropdown_field_text;
                } else {
                  r.VALUE = field.field_value;
                }
              }
            });
          });
        });
      });
    }

    let urn = this.transactionDetail.urn;
    let requestBody = {};
    requestBody['document_detail_id'] = this.documentDetailId;
    requestBody['document_type_id'] = this.transactionDetail.document_type_id;
    requestBody['process_id'] = this.transactionDetail.process_id;
    requestBody['project_id'] = this.commonService.selectedProject;
    requestBody['next_process_id'] = nextProcessId;
    requestBody['document_history_id'] = documentHistoryId;
    requestBody['doa_assigned_to'] = doaAssignedTo;
    requestBody['doa_matrix_id'] = this.doaMatrix.doa_matrix_id;
    requestBody['doa_level'] = doaLevel;
    // requestBody['user_id'] = Number(this.commonService.getUserInfoFromLocalStorage('userId'));
    requestBody['user_id'] = Number(this.memorystore.getItem('userId'));
    requestBody['field_vals'] = this.doaFields.length > 0 ? JSON.stringify(this.doaFields) : null;

    this.dataService.postData('approve-reject-document', requestBody).subscribe((res) => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success) {
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            disableClose: true,
            data: {
              title: 'Action taken',
              message: res.data.replace('#URN#', urn),
              buttonText: {
                ok: 'Ok',
                cancel: 'Next Transaction'
              }
            }
          });
          dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.clearAll();
              this.reloadPage.emit({ reload: true, action: 'ok' });
            } else {
              this.clearAll();
              this.reloadPage.emit({ reload: true, action: 'next' });
            }
          });
        } else {
          this.commonService.showMessageBox(res.errorMessage, 'Error');
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error IM1")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  scrollInvoicePrimaryDetail(event: Event, direction: string): void {
    if (direction == 'next')
      (<Element>event.currentTarget).previousElementSibling.scrollLeft += 100;
    else
      (<Element>event.currentTarget).nextElementSibling.scrollLeft -= 100;
    event.preventDefault();

  }

  getHistory() {

    if (this.documentDetailId == 0 || this.documentDetailId == null)
      return;

    if (this.showHistory == false && !this.isLoadedTranHistory) {
      this.isLoadedTranHistory = true;

      this.transactionHistoryList = [];
      this.fileAttachmentHistoryList = [];

      let params = new HttpParams();
      params = params.append('documentDetailId', this.documentDetailId);
      params = params.append('documentTypeId', this.transactionDetail.document_type_id);
      params = params.append('roleId', this.commonService.selectedRole);
      params = params.append('projectId', this.commonService.selectedProject);
      params = params.append('module_name', 'AP');
        params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));

      this.dataService.getData('transaction-history', params).subscribe(res => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res != null && res != undefined) {
            res.data.comments_history.forEach((x) => {
              this.transactionHistoryList.push({
                refId: x.id,
                fromProcess: x.from_process,
                toProcess: x.to_process,
                reason: x.reject_reason,
                changedDate: x.changed_dt,
                changedBy: x.changed_by,
                comment: (x.comments == null || x.comments == undefined ? '' : x.comments),
                //comment: x.comments,
                duration: this.commonService.secondsTo_dd_hh_mm_ss(x.duration),
                checklist: x.checklist,
              });
            });

            res.data.attachments_history.forEach((x) => {
              this.fileAttachmentHistoryList.push({
                id: x.attachment_id,
                attachmentMode: x.mode_of_attachment,
                fileName: x.attachment_name,
                actialFileName: x.actual_attachment_name,
                uploadedDate: x.created_dt,
                uploadedBy: x.created_by_name,
                bodyContent: x.body_content,
                isFinalMail: x.is_final_email,
                uploadedById: x.created_by_id,
                isSupportingFile: x.is_supporting_file,
                ref_history_id: x.document_history_id,
              });
            });

            res.data.doa_history.forEach((x) => {
              this.doaHistory.push({
                id: x.user_id,
                approver: x.approver,
                assignedBy: x.assigned_by,
                assignedDate: x.assigned_date,
                approvedBy: x.approved_by,
                approvedDate: x.approved_date,
                currentStatus: x.current_status,
                level: x.level,
                ref_history_id: x.document_history_id,
              });
            });

            this.hasRejectReasonInHistory =
              this.transactionHistoryList.findIndex((x) => x.reason != '') > -1;
            this.hasChecklistInHistory =
              this.transactionHistoryList.findIndex((x) => x.checklist != '') >
              -1;
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error IM1")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    }
    this.showHistory = !this.showHistory;
  }

  attachmentCount(refId: number): number {
    let result = this.fileAttachmentHistoryList.filter(x => x.ref_history_id == refId);
    return result != undefined ? result.length : 0;
  }

  showHideInvoice() {
    this.isDisplayPDFViewer = !this.isDisplayPDFViewer;
  }

  openInvoiceFile() {
    if(!this.transactionDetail.invoice_file[0].invoice_file_encoded == null)
    {
        let invoiceFileWindow = window.open("")
        invoiceFileWindow.document.write(`<style>body{margin:0;} iframe{border:none;}</style><iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(this.transactionDetail.invoice_file[0].invoice_file_encoded)}'></iframe>`);
    }
    else{
        this.commonService.showMessageBox("Invoice Not Found")
    }   
  }

  downloadAttachment(filePath: string) {
    if (filePath != '')
      this.commonService.openAttachment('', filePath);
  }

  onSelectFile(imgFile: any) {
    if (this.commonService.validateFileUpload(imgFile.target.files[0], this.supportDocValidFileExtensions, this.supportDocFileSize)) {
      if (imgFile.target.files && imgFile.target.files[0]) {

        this.fileName = imgFile.target.files[0].name;

        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.fileBase64FileString = reader.result.toString();
          this.uploadAttachment();
        };

        reader.readAsDataURL(imgFile.target.files[0]);
        this.fileInput.nativeElement.value = '';
      } else {
        this.fileName = 'Choose File';
      }
    }
  }

  uploadAttachment() {
    if (this.fileName == '' || this.fileName == undefined || this.fileName == 'Choose File' || this.fileBase64FileString.length == 0) {
      this.commonService.showMessageBox('Please choose attachment.', 'Alert');
      return;
    }

    let local_file_name = this.fileName.split('.').slice(0, -1).join('.')
    let local_extension = '.' + this.fileName.split('.').pop();
    let selected_file_name = this.dateFormat.transform(new Date(), 'yyyyMMddhhmmssSSS') + "^" + local_file_name.substring((local_file_name.length < 24 ? 0 : local_file_name.length - 24), (local_file_name.length < 24 ? local_file_name.length : 24));

    this.attachmentList.push({
      name: selected_file_name + local_extension,
      file: this.fileBase64FileString,
    });
    this.fileName = 'Choose File';
    this.fileBase64FileString = '';
    this.commonService.showMessageBox('Attachment uploaded.', 'Success');
  }

  deleteAttachment(index: number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: 'Are you sure want to delete this attachment?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // this.dataService.deleteData('transaction-attachments/' + id, null, null).subscribe(res => {
        //   this.fileAttachmentHistoryList = this.fileAttachmentHistoryList.filter(el => el.id !== id);
        // });
        this.attachmentList.splice(index, 1);
        this.commonService.showMessageBox('Attachment deleted.', 'Success');
      }
    });
  }

  submitAttachments(documentHistoryId: number) {
    this.attachmentList.forEach((item) => {
      let attachmentBody = {
        document_detail_id: Number(this.documentDetailId),
        document_type_id: Number(this.transactionDetail.document_type_id),
        project_id: Number(this.commonService.selectedProject),
        process_id: Number(this.transactionDetail.process_id),
        // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
        user_id: Number(this.memorystore.getItem('userId')),
        attachment_name: item.name,
        attachment_encoded: item.file,
        document_history_id: documentHistoryId,
        module_name: 'AP'
      };

      this.dataService.postData('transaction-attachments', attachmentBody).subscribe((res) => {
        if (res) {
          if (res != null && (res.errorMessage == null || res.errorMessage == "")) {

          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error IM1")
            }
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
    });
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalRef = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  validateTransactionAndSubmit(processId: number) {

    if (((this.doaMatrix.process_module == 'QUERY' && this.doaMatrix.forward_process_id != processId) || (this.doaMatrix.approved_process_id != processId && this.doaMatrix.forward_process_id != processId)) && (this.transactionComment == "" || this.transactionComment == undefined || this.transactionComment == null)) {
      this.commonService.showMessageBox('Comment is mandatory', 'Alert');
      return;
    }

    if (this.doaMatrix.forward_process_id == processId) {

      let params = new HttpParams();
      params = params.append('document_type_id', this.transactionDetail.document_type_id);
      params = params.append('project_id', this.commonService.selectedProject);
      params = params.append('forward_process_id', processId);

      this.dataService.getData('forward-approvers', params).subscribe((res) => {
        if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
          if (res.success == true) {
            if (res.data == null) {
              this.forwardApproverList = [];
              this.commonService.showMessageBox(res.errorMessage, 'Alert');
              return;
            }
            else {
              this.forwardApproverList = res.data;
              if (this.forwardApproverList.length == 1) {
                this.selectedForwardApprover = Number(this.forwardApproverList[0].USER_ID);
              }
              this.showModal(this.forwardApproverModal);
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error IM1")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

    }
    else {
      if (this.isDOAExists && this.doaApproverList.length > 0 && this.selectedDOAApprover == 0 && this.doaMatrix.doa_matrix_name != 'Open_Manual_Selection' && this.doaMatrix.rejected_process_id != processId) {
        if (!(this.doaMatrix.doa_matrix_name == 'Sequential' && this.doaMatrix.is_eligible == 1 && this.doaMatrix.is_mandatory_last_level_action == 0)) {
          this.commonService.showMessageBox('Please select DOA Approver from DOA Approver list', 'Alert');
          return;
        }
      }
      this.submitTransaction(processId);
    }
  }

  submitTransaction(nextProcessId: number) {
    if (this.modalReference != null) {
      this.modalReference.close();
    }
    if (this.doaMatrix.forward_process_id == nextProcessId && this.selectedForwardApprover == 0) {
      this.commonService.showMessageBox('Please select Forward Approver from the Approver list', 'Alert');
      return;
    }
    let urn = this.transactionDetail.urn;

    let request: any = {};
    request['project_id'] = this.commonService.selectedProject;
    request['sub_group_id'] = this.commonService.selectedSubgroup;
    request['document_type_id'] = this.transactionDetail.document_type_id;
    request['document_detail_id'] = this.documentDetailId.toString();
    request['process_id'] = this.transactionDetail.process_id;
    request['next_process_id'] = nextProcessId;
    request['comments'] = this.transactionComment;
    // request['user_id'] = Number(this.commonService.getUserInfoFromLocalStorage('userId'));
    request['user_id'] = Number(this.memorystore.getItem('userId'));
    this.dataService.postData('update-transaction-approver', request).subscribe(res => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true && res.data != null) {
          if (this.modalRef != null) {
            this.modalRef.close();
          }
          this.mainModalRef.close();
          let documentHistoryId = res.data.document_history_id;
          this.submitAttachments(documentHistoryId);

          if (this.isDOAExists && (this.doaMatrix.process_module != 'QUERY' || this.doaMatrix.forward_process_id == nextProcessId)) {
            this.submitDOA(documentHistoryId, nextProcessId);
          } else {
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
              disableClose: true,
              data: {
                title: 'Action taken',
                message: res.data.message.replace('#URN#', urn),
                buttonText: {
                  ok: 'Ok',
                  cancel: 'Next Transaction'
                }
              }
            });
            dialogRef.afterClosed().subscribe((confirmed: boolean) => {
              if (confirmed) {
                this.clearAll();
                this.reloadPage.emit({ reload: true, action: 'ok' });
              } else {
                this.clearAll();
                this.reloadPage.emit({ reload: true, action: 'next' });
              }
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error IM1")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

  getKeys(obj: any) {
    return Object.keys(obj);
  }

  checkRestrictedKeywords() {
    let foundedRestrictedKeyword = [];
    let input: any = this.transactionComment;
    this.restrictedKeywords.forEach(keyword => {
      if (input.includes(keyword.restrict)) {
        input = input.replaceAll(keyword.restrict, keyword.replace);
        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.transactionComment = input;
      this.commonService.showMessageBox('We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.', 'Warning');
    }
  }

  scrollLeft(event: any) {
    event.currentTarget.nextSibling.scrollLeft -= event.currentTarget.nextSibling.scrollWidth;
  }

  scrollRight(event: any) {
    event.currentTarget.previousSibling.scrollLeft += event.currentTarget.previousSibling.scrollWidth;
  }

  onTabClick(tab) {
    this.activeTab = tab;
  }

  getSupportingDocuments() {
    this.supportDocFileSize = {};
    this.supportDocValidFileExtensions = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('document_type_id', this.transactionDetail.document_type_id);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('document_type_id', this.encryptDecryptservice.encryptUsingAES256(this.transactionDetail.document_type_id));
    params = params.append('document_type', 'SUPPORTING_DOC');
    this.dataService
      .getData('upload-file-validation', params)
      .subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              this.supportDocFileSize = res.data[0] ?.file_size;
              this.supportDocValidFileExtensions = res.data[0] ?.file_type.split(',');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.router.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error IM1")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
  }

  showModalBody(modelTemplate, body: any, modalSize: string = 'lg', mode_of_attachment) {


    var parser = new DOMParser();
    var doc = parser.parseFromString(body, 'text/html');

    if (mode_of_attachment == 'Email')
      this.attachmentMailContent = doc.body.innerHTML;
    else
      this.attachmentMailContent = doc.body.innerText;

    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });


  }

  fetchSesLineItem() {

    if (this.fetchSesLineitemAPI == null || this.fetchSesLineitemAPI == undefined && this.fetchSesLineitemAPI != '') {
      return;
    }

    let apiParams = this.fetchSesLineitemAPI['PARAMETER'];
    let apiID = this.fetchSesLineitemAPI['API_ID'];

    if (apiParams != null) {
      apiParams = JSON.parse(apiParams);
    }

    let invalidFieldMsg = '';
    if (apiParams != null && typeof (apiParams) == 'object') {
      Object.keys(apiParams).forEach(p => {
        this.transactionFieldList[this.transactionDetail.tabs.filter(x => x.tab_field_type == 'NORMAL')[0].tab_id].forEach(section => {
          section.field_details.forEach(field => {
            if (field.db_column_name == apiParams[p]) {
              let val = field.field_value;
              if (val == null || val == undefined || val == '') {
                invalidFieldMsg += '- ' + field.field_name + '<br>';
              }
              apiParams[p] = field.field_value;
            }
          });
        });
      });
    }
    if (invalidFieldMsg != '') {
      this.commonService.showMessageBox('SES not created in SAP yet, it will be created after Invoice Approval.<br>Please go to PO Pull tab available on this screen to view the line items for which SES will be created.', 'Alert', 'error');
      return;
    }

    this.sesLineitemList = [];

    ////test data
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.sesLineitemList.push({ 'Row No': 1, 'Short Text': 'Test Text', 'SES Number': '758435647', 'Amount': 1000.00,'Line No1': 1, 'Short Text1': 'Test Text', 'SES Number1': '758435647', 'Amount1': 1000.00,'Line No2': 1, 'Short Text2': 'Test Text', 'SES Number2': '758435647', 'Amount2': 1000.00,'Line No3': 1, 'Short Text3': 'Test Text', 'SES Number3': '758435647', 'Amount3': 1000.00,'Line No4': 1, 'Short Text4': 'Test Text', 'SES Number4': '758435647', 'Amount4': 1000.00 });
    // this.showModal(this.sesLineitemModal, 'xl');

    this.dataService.post_realTimeApi(apiID, apiParams).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.status == true) {
          res = JSON.parse(JSON.parse(res.data));
          if (res != null && (res.status == true || res.status == 'success')) {
            if (res.data != null && res.data ?.item.length > 0) {
              this.sesLineitemList = res.data.item;
              this.showModal(this.sesLineitemModal, 'xl');
            } else {
              this.commonService.showMessageBox("SES line item not found.", "Alert");
            }
          }
          else {
            this.commonService.showMessageBox("SES line item not found.", "Alert");
          }
        } else {
          this.commonService.showMessageBox(res.error_message, 'Error');
          return;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error IM1")
        }
      }
    },
    error => {
      if (error.includes("401")) {
        this.router.navigateByUrl('/unauthorized');
        return;
      }
    });
  }

}

